import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
const purchases = [{
  name: 'Mariana G.',
  role: 'Tarotista principiante',
  location: 'La Plata',
  time: 'Hace 3 min'
}, {
  name: 'Lucía T.',
  role: 'Terapeuta Holística',
  location: 'Quilmes',
  time: 'Hace 5 min'
}, {
  name: 'Carolina M.',
  role: 'Estudiante de Tarot',
  location: 'Morón',
  time: 'Hace 8 min'
}, {
  name: 'Valentina R.',
  role: 'Lectora intuitiva',
  location: 'San Isidro',
  time: 'Hace 12 min'
}, {
  name: 'Sofía P.',
  role: 'Coach Espiritual',
  location: 'Lanús',
  time: 'Hace 15 min'
}, {
  name: 'Agustina L.',
  role: 'Tarotista Profesional',
  location: 'Avellaneda',
  time: 'Hace 18 min'
}, {
  name: 'Florencia D.',
  role: 'Astróloga',
  location: 'Tigre',
  time: 'Hace 22 min'
}, {
  name: 'Camila S.',
  role: 'Facilitadora',
  location: 'Lomas de Zamora',
  time: 'Hace 25 min'
}];
export function PurchasePopup() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const showFirst = setTimeout(() => {
      setVisible(true);
    }, 5000);
    return () => clearTimeout(showFirst);
  }, []);
  useEffect(() => {
    if (!visible) return;
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, 4000);
    const nextTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % purchases.length);
      setVisible(true);
    }, 7000);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, [visible, currentIndex]);
  const purchase = purchases[currentIndex];
  return <div className="fixed bottom-4 left-4 z-50" data-id="element-220">
      <AnimatePresence data-id="element-221">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        scale: 0.95
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="flex items-start gap-3 p-4 bg-[#1a1a1a] rounded-xl shadow-lg border border-brand-teal/20 max-w-xs" data-id="element-222">
            <div className="flex items-center justify-center w-10 h-10 rounded-full bg-brand-tealLight shrink-0" data-id="element-223">
              <ShoppingBagIcon className="w-5 h-5 text-brand-teal" data-id="element-224" />
            </div>
            <div className="min-w-0" data-id="element-225">
              <p className="text-sm font-semibold text-brand-dark leading-tight" data-id="element-226">
                {purchase.name}
              </p>
              <p className="text-xs text-brand-dark/70 mt-0.5" data-id="element-227">
                {purchase.role} — {purchase.location}
              </p>
              <p className="text-xs text-brand-amber font-medium mt-1" data-id="element-228">
                Compró el MegaPack · {purchase.time}
              </p>
            </div>
            <button onClick={() => setVisible(false)} className="text-brand-dark/30 hover:text-brand-dark/60 text-lg leading-none shrink-0 ml-1" aria-label="Cerrar notificación" data-id="element-229">
              ×
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}